export const RoomStyle = (theme) => ({
  modeNotification: {
    padding: '8px',
    backgroundColor: (props) => props.isSpectatorMode ? '#FFA500' : '#4CAF50',
    color: '#FFFFFF',
    fontWeight: 'bold',
    textAlign: 'center',
    borderRadius: '4px',
    margin: '8px 0',
  },
  container: {
    display: "grid",
    gridTemplateColumns: "60% 40%",
    padding: "10px",

    "@media (max-width: 800px)": {
      gridTemplateColumns: "100%",
    },
  },

  container2: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    padding: "0px 10px 10px",
    overflowY: "auto",
  },

  roomTabbedPanelWrapper: {
    width: "100%",
    display: "grid",
    gap: "12px",
  },

  roomTabsBar: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: "8px",
    alignItems: "center",
  },

  roomTabButton: {
    border: "1px solid rgba(255, 255, 255, 0.18)",
    background: "#161616",
    color: "#f5f5f5",
    borderRadius: "999px",
    padding: "10px 12px",
    fontSize: "12px",
    fontWeight: 700,
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    minHeight: "42px",
    "&:hover": {
      background: "#242424",
      transform: "translateY(-1px)",
    },
  },

  roomTabButtonActive: {
    background: "linear-gradient(135deg, #d44401, #ff7a1a)",
    color: "#fff",
    borderColor: "transparent",
    boxShadow: "0 6px 16px rgba(212, 68, 1, 0.28)",
  },

  roomPanelSurface: {
    background: "rgba(0, 0, 0, 0.18)",
    borderRadius: "12px",
    padding: "10px",
    minHeight: "220px",
  },

  roomPanelEmptyState: {
    textAlign: "center",
    color: "white",
    padding: "24px 12px",
    fontSize: "14px",
  },

  leftOuterBox: {
    // height: "200px",
  },

  rightOuterBox: {
    padding: "0px 10px",
  },

  roomTitle: {
    position: "relative",
    top: "20px",
    opacity: ({ showRoomTitle }) => (showRoomTitle ? "1" : "0"),
    transition: "opacity 0.3s ease-in-out",
  },

  roomSpeakingTag: {
    position: "relative",
    top: "30px",
    color: "white",
    left: "10px",
    zIndex: "100",
    // opacity: ({ showRoomTitle }) => (showRoomTitle ? "1" : "0"),
    // transition: "opacity 0.3s ease-in-out",
  },

  videoOptionsContainer: {
    transition: "opacity 0.8s ease-in-out",
    display: 'grid',
    gridTemplateColumns: "100%",
    position: 'relative',
    background: "rgba(223, 211, 211, 0.26)",
    bottom: '3px',
    padding: '3px',
    height: '40px',
    // bottom: "60px",
  },

  videoOptionsContainer2: {
    transition: "opacity 0.8s ease-in-out",
    display: 'grid',
    gridTemplateColumns: "100%",
    position: 'relative',
    background: "rgba(223, 211, 211, 0.26)",
    // bottom: "105px",
    bottom: "3px",
    padding: '3px',
    height: '100px',
  },

  reactionOptions: {
    width: 'fit-content',
    textAlign: 'center',
    background: 'rgba(0, 0, 0, 0.5)',
    margin: 'auto auto 5px',
    borderRadius: '10px'
  },

  reactionOptions2: {
    width: 'fit-content',
    textAlign: 'center',
    background: 'rgba(0, 0, 0, 0.5)',
    margin: 'auto',
    borderRadius: '10px'
  },

  webcamOptions: {
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    color: "white",
    margin: "auto",

    "@media (max-width: 800px)": {
      gap: "7px",
      height: "25px",
    },
  },

  videoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gridTemplateRows: "repeat(3, auto)", // Use "auto" to adjust the row height based on content
    columnGap: "16px",
    /* Add any additional styles for the video grid container */
  },
  videoCamBoxContainer: {
    display: "none",
  },
  videoCam: {
    // overflow: "hidden",
    width: "97%",
    margin: "auto",
    // height: "240px",
    objectFit: "cover",
    border: "2px solid #ddd",

    /* Add any additional styles for individual video elements */

    "&.otherParticipants": {
      // position: "relative",
      // bottom: "30px",
    },

    "&.admin": {
      border: "5px solid #595c8b",
      background: "#595c8b",
      color: "#00008b",
    },

    "&.team1": {
      border: "5px solid #add8e6",
      background: "#add8e6",
      color: "#00008b",
    },

    "&.team2": {
      border: "5px solid #98fb98",
      background: "#98fb98",
      color: "#006400",
    },

    "&.team3": {
      border: "5px solid #ffffe0",
      background: "#ffffe0",
      color: "#b8860b",
    },

    "&.team4": {
      border: "5px solid #e6e6fa",
      background: "#e6e6fa",
      color: "#9400d3",
    },

    "&.team5": {
      border: "5px solid #ffa07a",
      background: "#ffa07a",
      color: "#8b0000",
    },

    "&.team6": {
      border: "5px solid #d3d3d3",
      background: "#d3d3d3",
      color: "#2f4f4f",
    },

    "&.team7": {
      border: "5px solid #ffb6c1",
      background: "#ffb6c1",
      color: "#ff69b4",
    },

    "&.team-spectator": {
      border: "5px solid #ffb6c1",
      background: "#ffb6c1",
      color: "#ff69b4",
    },
  },
  /* Add responsive styles */
  [theme.breakpoints.down("sm")]: {
    videoGrid: {
      columnGap: "10px",
    },
    videoCam: {
      width: "100%",
      // height: "240px",
    },
  },

  emptyVideoCamContainerForSpectators: {
    position: "absolute",
    left: "40%",
    marginTop: "50px",
    textAlign: "center",
    fontSize: "20px",
    fontWeight: "bold",
  },

  videoCamForSpectators: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "8px",
  },

  iframe: {
    width: "100%",
    height: "100%",
  },

  participantRoomIdentifier: {
    display: "grid",
    gridTemplateColumns: "35% 30% 35%",
    position: "relative",
    height: "47px",
    zIndex: "1000",
    left: "5px",
    background: "#474648",
    alignItems: 'center',
    padding: '0px 5px'
  },

  reactionButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  participantRoomIdentifierForSpectators: {
    display: "grid",
    gridTemplateColumns: "50% 50%",
    position: "relative",
    height: "47px",
    zIndex: "1000",
    left: "5px",
    background: "#474648",
    alignItems: 'center',
    padding: '0px 5px'
  },

  videoOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', /* Background color for the overlay */
    color: '#fff', /* Text color for the overlay */
    padding: '20px',
    zIndex: 1, /* Place the overlay on top of the video */
  },

  reactionIconIdentifier: {
    position: "relative",
    // right: "5px",
    textAlign: "right",
    zIndex: '999'
  },

  innerReactionIconIdentifier: {
    width: '25px', height: '25px', background: 'crimson', borderRadius: '50px', float: 'right'
  },

  innerOtherParticipantReactionIconIdentifier: {
    width: '25px', height: '25px', background: 'crimson', borderRadius: '50px', float: 'right',
    position: 'relative',
    bottom: '5px'
  },

  usernameIdentifier: {
    height: 'fit-content',
    background: "crimson",
    maxWidth: "100%",
    borderRadius: "5px",
    padding: "5px",
    display: 'flex',
    justifyContent: 'flex-start',
    justifySelf: 'flex-start',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },

  userTeamNameIdentifier: {
    height: 'fit-content',
    maxWidth: "100%",
    borderRadius: "5px",
    padding: "5px",
    display: 'flex',
    justifyContent: 'flex-end',
    justifySelf: 'flex-end',
    overflow: 'hidden',
    whiteSpace: 'nowrap',

    /* Add any additional styles for individual video elements */
    "&.admin": {
      // border: "2px solid crimson",
      background: "#595c8b",
      color: "#fff",
    },

    "&.team1": {
      // border: "2px solid crimson",
      background: "#add8e6",
      color: "#00008b",
    },

    "&.team2": {
      // border: "2px solid crimson",
      background: "#98fb98",
      color: "#006400",
    },

    "&.team3": {
      // border: "2px solid crimson",
      background: "#ffffe0",
      color: "#b8860b",
    },

    "&.team4": {
      // border: "2px solid crimson",
      background: "#e6e6fa",
      color: "#9400d3",
    },

    "&.team5": {
      // border: "2px solid crimson",
      background: "#ffa07a",
      color: "#8b0000",
    },

    "&.team6": {
      // border: "2px solid crimson",
      background: "#d3d3d3",
      color: "#2f4f4f",
    },

    "&.team7": {
      // border: "2px solid crimson",
      background: "#ffb6c1",
      color: "#ff69b4",
    },
  },

  customTabPanelStyles: {
    padding: "0px",
    width: "300px",
    maxWidth: "300px",

    "@media (max-width: 420px)": {
      width: "auto",
      maxWidth: "auto",
    },
  },

  customFormContainerStyles: {
    maxHeight: "300px",
  },

  buttonStyles: {
    width: "100%",
    margin: "10px 0px",
  },

  textMiddle: {
    textAlign: "center",
    padding: "0 0 12px",
  },

  textMiddle2: {
    textAlign: "center",
    padding: "0 0 12px",
  },

  searchBox: {
    width: "100%",
    maxWidth: "420px",
    boxSizing: "border-box",
    padding: "12px 14px",
    color: "#ffffff",
    background: "linear-gradient(135deg, #111111 0%, #1d1d1d 100%)",
    border: "1px solid rgba(255, 107, 53, 0.28)",
    borderRadius: "10px",
    outline: "none",
    boxShadow: "0 6px 18px rgba(0, 0, 0, 0.18)",
    transition: "all 0.2s ease-in-out",
    "&::placeholder": {
      color: "rgba(255, 255, 255, 0.55)",
    },
    "&:focus": {
      borderColor: "#ff7a1a",
      boxShadow: "0 0 0 3px rgba(255, 122, 26, 0.18)",
    },
  },

  userLobbyButton: {
    padding: "10px 12px",
    margin: "0 auto 8px",
    textAlign: "left",
    width: "100%",
    boxSizing: "border-box",
    color: "#ffffff",
    background: "linear-gradient(135deg, #111111 0%, #1d1d1d 100%)",
    border: "1px solid rgba(255, 107, 53, 0.22)",
    borderLeft: "4px solid #ff6b35",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.18)",
  },

  userLobbyDisabledButton: {
    padding: "10px 12px",
    margin: "0 auto 8px",
    textAlign: "left",
    width: "100%",
    boxSizing: "border-box",
    color: "#f3f3f3",
    background: "linear-gradient(135deg, #3a2f3d 0%, #56455a 100%)",
    border: "1px solid rgba(255, 255, 255, 0.12)",
    borderLeft: "4px solid #9d8aa3",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.16)",
  },

  userLobbyInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: "2px",
    minWidth: 0,
    fontSize: "14px",
    fontWeight: 600,
  },

  userLobbyAdminInfo: {
    marginLeft: 0,
    display: "flex",
    gap: "6px",
    flexWrap: "wrap",
    alignItems: "center",
    fontSize: "11px",
    fontWeight: 500,
  },

  userLobbyMoreIconButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "6px",
    minWidth: "92px",
    paddingLeft: "8px",
    borderLeft: "1px solid rgba(255, 255, 255, 0.08)",
  },

  userLobbyProfileIconButton: {
    color: "white",
    padding: "4px",
    background: "rgba(255, 255, 255, 0.06)",
    borderRadius: "8px",
  },

  onlineGreenDot: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    backgroundColor: "#47F90B",
    display: "inline-block",
    boxShadow: "0 0 10px rgba(71, 249, 11, 0.55)",
    border: "1px solid rgba(255, 255, 255, 0.45)",
  },

  offlineRedDot: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    backgroundColor: "tomato",
    display: "inline-block",
    boxShadow: "0 0 10px rgba(255, 99, 71, 0.4)",
    border: "1px solid rgba(255, 255, 255, 0.35)",
  },

  userLobbyList: {
    maxHeight: "260px",
    overflow: "auto",
    whiteSpace: "nowrap",
    margin: "0 0 10px",
    padding: "4px",
    scrollBehavior: "smooth",
    borderRadius: "10px",
    background: "rgba(0, 0, 0, 0.12)",
    "&::-webkit-scrollbar": {
      width: "0.45em",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(255, 255, 255, 0.08)",
      borderRadius: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "linear-gradient(180deg, #ff6b35 0%, #ff8c42 100%)",
      borderRadius: "8px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "linear-gradient(180deg, #ff8c42 0%, #ff6b35 100%)",
    },
  },

  roomTeamHeader: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 110px",
    gap: "8px",
    textAlign: "center",
    margin: "0 0 8px",

    "@media (max-width: 600px)": {
      gridTemplateColumns: "minmax(0, 1fr) 90px",
    },
  },

  roomTeamContainer: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 110px",
    gap: "8px",
    alignItems: "stretch",
    textAlign: "center",
    margin: "0 0 8px",

    "@media (max-width: 600px)": {
      gridTemplateColumns: "minmax(0, 1fr) 90px",
    },
  },

  roomTeamInnerHeader: {
    background: "linear-gradient(135deg, #d44401, #ff7a1a)",
    color: "#ffffff",
    padding: "10px 12px",
    borderRadius: "10px",
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    boxShadow: "0 6px 16px rgba(212, 68, 1, 0.28)",
  },

  roomTeamName: {
    padding: "12px 14px",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: "10px",
    fontWeight: 600,
    textAlign: "left",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.14)",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  roomTeamScore: {
    padding: "12px 10px",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: "10px",
    fontWeight: 700,
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.14)",
  },
  
  // Add the keyframe animation
  "@keyframes fadeIn": {
    from: {
      opacity: 0,
      transform: "translateY(10px)",
    },
    to: {
      opacity: 1,
      transform: "translateY(0)",
    },
  },

  spectatorVotesContainer: {
    position: "absolute",
    bottom: "100px",
    right: "10px",
    zIndex: 1000,
    display: "flex",
    flexDirection: "column-reverse", // Changed to reverse to show new votes from bottom
    gap: "5px",
    pointerEvents: "none",
    maxHeight: "200px",
    overflow: "hidden",
  },
  
  voteContainer: {
    display: "flex",
    alignItems: "center",
    background: "rgba(0, 0, 0, 0.6)",
    padding: "4px 8px",
    borderRadius: "20px",
    animation: "$floatAndFade 3s ease-out forwards",
    marginBottom: "4px",
    maxWidth: "200px",
  },
  
  voteIcon: {
    marginRight: "6px",
    fontSize: "14px",
  },
  
  voteDescription: {
    color: "white",
    fontSize: "11px",
    fontWeight: 400,
  },
  
  spectatorVotingButtons: {
    position: "absolute",
    bottom: "65px",
    right: "10px",
    zIndex: 1000,
    display: "flex",
    gap: "8px",
    background: "rgba(0, 0, 0, 0.6)",
    padding: "6px",
    borderRadius: "24px",
    transition: "all 0.3s ease",
  },
  
  teamScoreSection: {
    position: "absolute",
    bottom: "65px",
    left: "10px",
    zIndex: 1000,
    display: "flex",
    gap: "8px",
    background: "rgba(0, 0, 0, 0.6)",
    padding: "6px",
    borderRadius: "24px",
    transition: "all 0.3s ease",
  },

  toggleVoteButtons: {
    zIndex: 1000,
    background: "rgba(0, 0, 0, 0.6)",
    borderRadius: "50%",
    padding: "4px",
    width: "28px",
    height: "28px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },

  toggleVoteButtonsHide: {
    zIndex: 1000,
    background: "rgba(39, 39, 39, 0.6)",
    borderRadius: "50%",
    padding: "4px",
    width: "28px",
    height: "28px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },

  spectatorButton: {
    padding: "4px !important",
    minWidth: "32px !important",
    minHeight: "32px !important",
    borderRadius: "50% !important",
    
    "& .MuiSvgIcon-root": {
      fontSize: "16px !important",
    },
  },

  voteCount: {
    position: "absolute",
    top: "-8px",
    right: "-8px",
    background: "#1976d2",
    color: "white",
    fontSize: "10px",
    padding: "2px 4px",
    borderRadius: "10px",
    minWidth: "16px",
    textAlign: "center",
  },
  
  votedButton: {
    backgroundColor: "rgba(255, 215, 0, 0.2) !important",
    '&:disabled': {
      opacity: 0.7,
    }
  },
  
  "@keyframes floatAndFade": {
    "0%": {
      transform: "translateY(20px)",
      opacity: 0
    },
    "15%": {
      transform: "translateY(0)",
      opacity: 1
    },
    "85%": {
      transform: "translateY(0)",
      opacity: 1
    },
    "100%": {
      transform: "translateY(-20px)",
      opacity: 0
    }
  }
});
